import Service from "../../../common/services/service";

export default class FormProvider extends Service {
  create({organizationId, folderIdTree, form, applicationId}) {
    return this.persist({
      method: 'post',
      json: {
        form: form,
        organization_id: organizationId,
        folder_id_tree: folderIdTree,
        application_id: applicationId,
      }
    });
  }

  clone({organizationId, folderIdTree, formId, title, reference_name}) {
    return this.persist({
      method: 'post',
      json: {
        title: title,
        reference_name: reference_name,
        form_id: formId,
        organization_id: organizationId,
        folder_id_tree: folderIdTree
      },
      endpoint: `${formId}/clone`
    });
  }

  persist({ endpoint = '', json, method = 'put' }:any) {
    return new Promise((resolve, reject) => {
      const data = {
        _method: method,
        authenticity_token: this.csrfToken(),
        source: 'forms'
      };

      if (json) {
        window.AppConfig.mergeJson(data, json);
      }

      $.ajax({
        url: `/forms/${endpoint}`,
        type: 'POST',
        dataType: 'json',
        data: data,
      }).done(function (result) {
        resolve(result);
      }).fail(function (result) {
        reject();
      });
    });
  }
}
